(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[703],{

/***/ 1550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ dropdown_footer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/dropdown-footer/styles.scoped.css
var styles_scoped = __webpack_require__(9656);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/dropdown-footer/styles.css.js

/* harmony default export */ var styles_css = ({
    "root": "awsui_root_1afi9_19bf4_93",
    "hidden": "awsui_hidden_1afi9_19bf4_103",
    "no-items": "awsui_no-items_1afi9_19bf4_106"
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/dropdown-status/index.js + 3 modules
var dropdown_status = __webpack_require__(5094);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/dropdown-footer/index.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




var DropdownFooter = function(_a) {
    var _b;
    var content = _a.content, _c = _a.hasItems, hasItems = _c === void 0 ? true : _c;
    return /*#__PURE__*/ react.createElement("div", {
        className: (0,clsx_m/* default */.Z)(styles_css.root, (_b = {}, _b[styles_css.hidden] = content === null, _b[styles_css["no-items"]] = !hasItems, _b)),
        "aria-live": "polite",
        "aria-atomic": "true"
    }, content && /*#__PURE__*/ react.createElement(dropdown_status/* default */.Z, null, content));
};
/* harmony default export */ var dropdown_footer = (DropdownFooter); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 5094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ dropdown_status; },
  "w": function() { return /* binding */ useDropdownStatus; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/link/internal.js + 1 modules
var internal = __webpack_require__(8791);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/status-indicator/styles.scoped.css
var styles_scoped = __webpack_require__(925);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/status-indicator/styles.css.js

/* harmony default export */ var styles_css = ({
    "icon-shake": "awsui_icon-shake_1cbgc_1dmb0_97",
    "awsui-motion-shake-horizontally": "awsui_awsui-motion-shake-horizontally_1cbgc_1dmb0_1",
    "container-fade-in": "awsui_container-fade-in_1cbgc_1dmb0_125",
    "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1cbgc_1dmb0_1",
    "root": "awsui_root_1cbgc_1dmb0_147",
    "status-error": "awsui_status-error_1cbgc_1dmb0_154",
    "status-warning": "awsui_status-warning_1cbgc_1dmb0_157",
    "status-success": "awsui_status-success_1cbgc_1dmb0_160",
    "status-info": "awsui_status-info_1cbgc_1dmb0_163",
    "status-stopped": "awsui_status-stopped_1cbgc_1dmb0_166",
    "status-pending": "awsui_status-pending_1cbgc_1dmb0_169",
    "status-in-progress": "awsui_status-in-progress_1cbgc_1dmb0_172",
    "status-loading": "awsui_status-loading_1cbgc_1dmb0_175",
    "color-override-red": "awsui_color-override-red_1cbgc_1dmb0_178",
    "color-override-grey": "awsui_color-override-grey_1cbgc_1dmb0_181",
    "color-override-blue": "awsui_color-override-blue_1cbgc_1dmb0_184",
    "color-override-green": "awsui_color-override-green_1cbgc_1dmb0_187",
    "icon": "awsui_icon_1cbgc_1dmb0_97",
    "container": "awsui_container_1cbgc_1dmb0_125",
    "overflow-ellipsis": "awsui_overflow-ellipsis_1cbgc_1dmb0_201"
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/icon/internal.js + 2 modules
var icon_internal = __webpack_require__(776);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/spinner/internal.js + 1 modules
var spinner_internal = __webpack_require__(1970);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/status-indicator/internal.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0






var typeToIcon = function(size) {
    return {
        error: /*#__PURE__*/ react.createElement(icon_internal/* default */.Z, {
            name: "status-negative",
            size: size
        }),
        warning: /*#__PURE__*/ react.createElement(icon_internal/* default */.Z, {
            name: "status-warning",
            size: size
        }),
        success: /*#__PURE__*/ react.createElement(icon_internal/* default */.Z, {
            name: "status-positive",
            size: size
        }),
        info: /*#__PURE__*/ react.createElement(icon_internal/* default */.Z, {
            name: "status-info",
            size: size
        }),
        stopped: /*#__PURE__*/ react.createElement(icon_internal/* default */.Z, {
            name: "status-stopped",
            size: size
        }),
        pending: /*#__PURE__*/ react.createElement(icon_internal/* default */.Z, {
            name: "status-pending",
            size: size
        }),
        "in-progress": /*#__PURE__*/ react.createElement(icon_internal/* default */.Z, {
            name: "status-in-progress",
            size: size
        }),
        loading: /*#__PURE__*/ react.createElement(spinner_internal/* default */.Z, null)
    };
};
function StatusIndicator(_a) {
    var _b;
    var type = _a.type, children = _a.children, iconAriaLabel = _a.iconAriaLabel, colorOverride = _a.colorOverride, _c = _a.wrapText, wrapText = _c === void 0 ? true : _c, _d = _a.__animate, __animate = _d === void 0 ? false : _d, __internalRootRef = _a.__internalRootRef, _e = _a.__size, __size = _e === void 0 ? "normal" : _e, rest = (0,tslib_es6/* __rest */._T)(_a, [
        "type",
        "children",
        "iconAriaLabel",
        "colorOverride",
        "wrapText",
        "__animate",
        "__internalRootRef",
        "__size"
    ]);
    var baseProps = (0,base_component/* getBaseProps */.j)(rest);
    return /*#__PURE__*/ react.createElement("span", (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        className: (0,clsx_m/* default */.Z)(styles_css.root, styles_css["status-".concat(type)], (_b = {}, _b[styles_css["color-override-".concat(colorOverride)]] = colorOverride, _b), baseProps.className),
        ref: __internalRootRef
    }), /*#__PURE__*/ react.createElement("span", {
        className: (0,clsx_m/* default */.Z)(styles_css.container, wrapText === false && styles_css["overflow-ellipsis"], __animate && styles_css["container-fade-in"])
    }, /*#__PURE__*/ react.createElement("span", {
        className: (0,clsx_m/* default */.Z)(styles_css.icon, __animate && styles_css["icon-shake"]),
        "aria-label": iconAriaLabel,
        role: iconAriaLabel ? "img" : undefined
    }, typeToIcon(__size)[type]), children));
} //# sourceMappingURL=internal.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/events/index.js
var events = __webpack_require__(6322);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-previous/index.js
var use_previous = __webpack_require__(8518);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/dropdown-status/styles.scoped.css
var dropdown_status_styles_scoped = __webpack_require__(4926);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/dropdown-status/styles.css.js

/* harmony default export */ var dropdown_status_styles_css = ({
    "root": "awsui_root_vrgzu_1obpu_93",
    "recovery": "awsui_recovery_vrgzu_1obpu_105"
});

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/dropdown-status/index.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0






function DropdownStatus(_a) {
    var children = _a.children;
    return /*#__PURE__*/ react.createElement("div", {
        className: dropdown_status_styles_css.root,
        "aria-live": "polite"
    }, children);
}
var useDropdownStatus = function(_a) {
    var statusType = _a.statusType, empty = _a.empty, loadingText = _a.loadingText, finishedText = _a.finishedText, errorText = _a.errorText, recoveryText = _a.recoveryText, isEmpty = _a.isEmpty, isNoMatch = _a.isNoMatch, noMatch = _a.noMatch, onRecoveryClick = _a.onRecoveryClick;
    var previousStatusType = (0,use_previous/* usePrevious */.D)(statusType);
    var statusResult = {
        isSticky: true,
        content: null
    };
    if (statusType === "loading") {
        statusResult.content = /*#__PURE__*/ react.createElement(StatusIndicator, {
            type: "loading"
        }, loadingText);
    } else if (statusType === "error") {
        statusResult.content = /*#__PURE__*/ react.createElement("span", null, /*#__PURE__*/ react.createElement(StatusIndicator, {
            type: "error",
            __animate: previousStatusType !== "error"
        }, errorText), " ", recoveryText && /*#__PURE__*/ react.createElement(internal/* default */.Z, {
            onFollow: function() {
                return (0,events/* fireNonCancelableEvent */.B4)(onRecoveryClick);
            },
            variant: "recovery",
            className: dropdown_status_styles_css.recovery
        }, recoveryText));
    } else if (isEmpty && empty) {
        statusResult.content = empty;
    } else if (isNoMatch && noMatch) {
        statusResult.content = noMatch;
    } else if (statusType === "finished" && finishedText) {
        statusResult.content = finishedText;
        statusResult.isSticky = false;
    }
    return statusResult;
};
/* harmony default export */ var dropdown_status = (DropdownStatus); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 3999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_option; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/option/styles.scoped.css
var styles_scoped = __webpack_require__(1176);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/option/styles.css.js

/* harmony default export */ var styles_css = ({
    "option": "awsui_option_1p2cx_1tubf_97",
    "disabled": "awsui_disabled_1p2cx_1tubf_113",
    "parent": "awsui_parent_1p2cx_1tubf_116",
    "content": "awsui_content_1p2cx_1tubf_123",
    "label-content": "awsui_label-content_1p2cx_1tubf_130",
    "label": "awsui_label_1p2cx_1tubf_130",
    "tag": "awsui_tag_1p2cx_1tubf_137",
    "label-tag": "awsui_label-tag_1p2cx_1tubf_138",
    "label-prefix": "awsui_label-prefix_1p2cx_1tubf_149",
    "tags": "awsui_tags_1p2cx_1tubf_162",
    "description": "awsui_description_1p2cx_1tubf_163",
    "icon": "awsui_icon_1p2cx_1tubf_180",
    "icon-size-big": "awsui_icon-size-big_1p2cx_1tubf_187",
    "filtering-match-highlight": "awsui_filtering-match-highlight_1p2cx_1tubf_191",
    "trigger-variant": "awsui_trigger-variant_1p2cx_1tubf_206"
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/icon/internal.js + 2 modules
var internal = __webpack_require__(776);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/option/highlight-match.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0



var splitOnFiltering = function(str, highlightText) {
    // Filtering needs to be case insensitive
    var filteringPattern = highlightText.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
    var regexp = new RegExp(filteringPattern, "gi");
    var noMatches = str.split(regexp);
    var matches = str.match(regexp);
    return {
        noMatches: noMatches,
        matches: matches
    };
};
var Highlight = function(_a) {
    var str = _a.str;
    return str ? /*#__PURE__*/ react.createElement("span", {
        className: (0,clsx_m/* default */.Z)(styles_css["filtering-match-highlight"])
    }, str) : null;
};
function HighlightMatch(_a) {
    var str = _a.str, highlightText = _a.highlightText;
    if (!str || !highlightText) {
        return /*#__PURE__*/ react.createElement(react.Fragment, null, str);
    }
    if (str === highlightText) {
        return /*#__PURE__*/ react.createElement(Highlight, {
            str: str
        });
    }
    var _b = splitOnFiltering(str, highlightText), noMatches = _b.noMatches, matches = _b.matches;
    var highlighted = [];
    noMatches.forEach(function(noMatch, idx) {
        highlighted.push(noMatch);
        if (matches && idx < matches.length) {
            highlighted.push(/*#__PURE__*/ react.createElement(Highlight, {
                key: idx,
                str: matches[idx]
            }));
        }
    });
    return /*#__PURE__*/ react.createElement("span", null, highlighted);
} //# sourceMappingURL=highlight-match.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/option/option-parts.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0





var Label = function(_a) {
    var label = _a.label, prefix = _a.prefix, highlightText = _a.highlightText, triggerVariant = _a.triggerVariant;
    return /*#__PURE__*/ react.createElement("span", {
        className: (0,clsx_m/* default */.Z)(styles_css.label, triggerVariant && styles_css["trigger-variant"])
    }, prefix && /*#__PURE__*/ react.createElement("span", {
        className: (0,clsx_m/* default */.Z)(styles_css["label-prefix"], triggerVariant && styles_css["trigger-variant"])
    }, prefix, " "), /*#__PURE__*/ react.createElement(HighlightMatch, {
        str: label,
        highlightText: highlightText
    }));
};
var LabelTag = function(_a) {
    var labelTag = _a.labelTag, highlightText = _a.highlightText, triggerVariant = _a.triggerVariant;
    return labelTag ? /*#__PURE__*/ react.createElement("span", {
        className: (0,clsx_m/* default */.Z)(styles_css["label-tag"], triggerVariant && styles_css["trigger-variant"])
    }, /*#__PURE__*/ react.createElement(HighlightMatch, {
        str: labelTag,
        highlightText: highlightText
    })) : null;
};
var Description = function(_a) {
    var description = _a.description, highlightText = _a.highlightText, triggerVariant = _a.triggerVariant;
    return description ? // TODO: Remove aria-disabled={true} when we fix AWSUI-10333
    /*#__PURE__*/ react.createElement("span", {
        className: (0,clsx_m/* default */.Z)(styles_css.description, triggerVariant && styles_css["trigger-variant"]),
        "aria-disabled": true
    }, /*#__PURE__*/ react.createElement(HighlightMatch, {
        str: description,
        highlightText: highlightText
    })) : null;
};
var Tags = function(_a) {
    var tags = _a.tags, highlightText = _a.highlightText, triggerVariant = _a.triggerVariant;
    return tags ? /*#__PURE__*/ react.createElement("span", {
        className: (0,clsx_m/* default */.Z)(styles_css.tags)
    }, tags.map(function(tag, idx) {
        return(// TODO: Remove aria-disabled={true} when we fix AWSUI-10333
        /*#__PURE__*/ react.createElement("span", {
            key: idx,
            className: (0,clsx_m/* default */.Z)(styles_css.tag, triggerVariant && styles_css["trigger-variant"]),
            "aria-disabled": true
        }, /*#__PURE__*/ react.createElement(HighlightMatch, {
            str: tag,
            highlightText: highlightText
        })));
    })) : null;
};
var FilteringTags = function(_a) {
    var filteringTags = _a.filteringTags, highlightText = _a.highlightText, triggerVariant = _a.triggerVariant;
    if (!highlightText || !filteringTags) {
        return null;
    }
    var searchElement = highlightText.toLowerCase();
    return /*#__PURE__*/ react.createElement("span", {
        className: (0,clsx_m/* default */.Z)(styles_css.tags)
    }, filteringTags.map(function(filteringTag, key) {
        var match = filteringTag.toLowerCase().indexOf(searchElement) !== -1;
        if (match) {
            return(// TODO: Remove aria-disabled={true} when we fix AWSUI-10333
            /*#__PURE__*/ react.createElement("span", {
                className: (0,clsx_m/* default */.Z)(styles_css.tag, triggerVariant && styles_css["trigger-variant"]),
                key: key,
                "aria-disabled": true
            }, /*#__PURE__*/ react.createElement(HighlightMatch, {
                str: filteringTag,
                highlightText: highlightText
            })));
        }
        return null;
    }));
};
var OptionIcon = function(props) {
    if (!props.name && !props.url && !props.svg) {
        return null;
    }
    return /*#__PURE__*/ react.createElement("span", {
        className: (0,clsx_m/* default */.Z)(styles_css.icon, props.size === "big" && [
            styles_css["icon-size-big"]
        ])
    }, /*#__PURE__*/ react.createElement(internal/* default */.Z, (0,tslib_es6/* __assign */.pi)({}, props)));
}; //# sourceMappingURL=option-parts.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/logging.js
var logging = __webpack_require__(3742);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/is-development.js
var is_development = __webpack_require__(5856);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/option/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0







function validateStringValue(value, propertyName) {
    if (typeof value !== "undefined" && typeof value !== "string") {
        (0,logging/* warnOnce */.O)("DropdownOption", 'This component only supports string values, but "option.'.concat(propertyName, '" has ').concat(typeof value, " type. The component may work incorrectly."));
    }
}
var Option = function(_a) {
    var _b, _c, _d, _e;
    var option = _a.option, highlightText = _a.highlightText, _f = _a.triggerVariant, triggerVariant = _f === void 0 ? false : _f, _g = _a.isGroupOption, isGroupOption = _g === void 0 ? false : _g, restProps = (0,tslib_es6/* __rest */._T)(_a, [
        "option",
        "highlightText",
        "triggerVariant",
        "isGroupOption"
    ]);
    if (!option) {
        return null;
    }
    var disabled = option.disabled;
    var baseProps = (0,base_component/* getBaseProps */.j)(restProps);
    if (is_development/* isDevelopment */.y) {
        validateStringValue(option.label, "label");
        validateStringValue(option.description, "description");
        validateStringValue(option.labelTag, "labelTag");
        (_b = option.tags) === null || _b === void 0 ? void 0 : _b.forEach(function(tag, index) {
            validateStringValue(tag, "tags[".concat(index, "]"));
        });
        (_c = option.filteringTags) === null || _c === void 0 ? void 0 : _c.forEach(function(tag, index) {
            validateStringValue(tag, "filteringTags[".concat(index, "]"));
        });
    }
    var className = (0,clsx_m/* default */.Z)(styles_css.option, disabled && styles_css.disabled, isGroupOption && styles_css.parent);
    var icon = option.__customIcon || /*#__PURE__*/ react.createElement(OptionIcon, {
        name: option.iconName,
        url: option.iconUrl,
        svg: option.iconSvg,
        alt: option.iconAlt,
        size: option.description || option.tags ? "big" : "normal"
    });
    return /*#__PURE__*/ react.createElement("span", (0,tslib_es6/* __assign */.pi)({
        title: (_d = option.label) !== null && _d !== void 0 ? _d : option.value,
        "data-value": option.value,
        className: className,
        "aria-disabled": disabled
    }, baseProps), icon, /*#__PURE__*/ react.createElement("span", {
        className: (0,clsx_m/* default */.Z)(styles_css.content)
    }, /*#__PURE__*/ react.createElement("span", {
        className: (0,clsx_m/* default */.Z)(styles_css["label-content"])
    }, /*#__PURE__*/ react.createElement(Label, {
        label: (_e = option.label) !== null && _e !== void 0 ? _e : option.value,
        prefix: option.__labelPrefix,
        highlightText: highlightText,
        triggerVariant: triggerVariant
    }), /*#__PURE__*/ react.createElement(LabelTag, {
        labelTag: option.labelTag,
        highlightText: highlightText,
        triggerVariant: triggerVariant
    })), /*#__PURE__*/ react.createElement(Description, {
        description: option.description,
        highlightText: highlightText,
        triggerVariant: triggerVariant
    }), /*#__PURE__*/ react.createElement(Tags, {
        tags: option.tags,
        highlightText: highlightText,
        triggerVariant: triggerVariant
    }), /*#__PURE__*/ react.createElement(FilteringTags, {
        filteringTags: option.filteringTags,
        highlightText: highlightText,
        triggerVariant: triggerVariant
    })));
};
/* harmony default export */ var components_option = (Option); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 9720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ generateTestIndexes; },
/* harmony export */   "w": function() { return /* binding */ getTestOptionIndexes; }
/* harmony export */ });
var testIndexMap = new WeakMap();
//retrieves the test indexes of the option for the findOption and findOptionInGroup test-utils
var getTestOptionIndexes = function(item) {
    return testIndexMap.get(item);
};
var generateTestIndexes = function(filteredItems, getParentGroup) {
    var throughIndex = 1;
    var groupIndex = 0;
    var inGroupIndex = 1;
    var currentGroup = null;
    filteredItems.forEach(function(item) {
        if (!("type" in item)) {
            testIndexMap.set(item, {
                throughIndex: throughIndex++
            });
        } else if (item.type === "child") {
            var parentGroup = getParentGroup(item);
            if (parentGroup && parentGroup !== currentGroup) {
                currentGroup = parentGroup;
                inGroupIndex = 1;
                testIndexMap.set(item, {
                    throughIndex: throughIndex++,
                    groupIndex: ++groupIndex,
                    inGroupIndex: inGroupIndex++
                });
            } else {
                testIndexMap.set(item, {
                    throughIndex: throughIndex++,
                    groupIndex: groupIndex,
                    inGroupIndex: inGroupIndex++
                });
            }
        }
    });
}; //# sourceMappingURL=test-indexes.js.map


/***/ }),

/***/ 3509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useHighlightedOption; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function useHighlightedOption(_a) {
    var options = _a.options, isHighlightable = _a.isHighlightable;
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(-1), highlightedIndex = _b[0], setHighlightedIndexState = _b[1];
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("keyboard"), highlightType = _c[0], setHighlightType = _c[1];
    var setHighlightedIndex = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(index, highlightType) {
        setHighlightedIndexState(index);
        setHighlightType(highlightType);
    }, []);
    var highlightedOption = options[highlightedIndex] && isHighlightable(options[highlightedIndex]) ? options[highlightedIndex] : undefined;
    var moveHighlightFrom = function(direction, startIndex, highlightType) {
        if (startIndex === void 0) {
            startIndex = highlightedIndex;
        }
        var newIndex = startIndex;
        do {
            newIndex += direction;
        }while (options[newIndex] && !isHighlightable(options[newIndex]));
        if (options[newIndex]) {
            setHighlightedIndex(newIndex, highlightType);
        }
    };
    var moveHighlight = function(direction, highlightType) {
        return moveHighlightFrom(direction, highlightedIndex, highlightType);
    };
    var highlightOption = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(option, highlightType) {
        var index = options.indexOf(option);
        setHighlightedIndex(index, highlightType);
    }, [
        options,
        setHighlightedIndex
    ]);
    return [
        {
            highlightType: highlightType,
            highlightedIndex: highlightedIndex,
            highlightedOption: highlightedOption
        },
        {
            setHighlightedIndexWithMouse: function(index) {
                return setHighlightedIndex(index, "mouse");
            },
            moveHighlightWithKeyboard: function(direction) {
                return moveHighlight(direction, "keyboard");
            },
            highlightOptionWithKeyboard: function(option) {
                return highlightOption(option, "keyboard");
            },
            resetHighlightWithKeyboard: function() {
                return setHighlightedIndex(-1, "keyboard");
            },
            goHomeWithKeyboard: function() {
                return moveHighlightFrom(1, -1, "keyboard");
            },
            goEndWithKeyboard: function() {
                return moveHighlightFrom(-1, options.length, "keyboard");
            }
        }
    ];
} //# sourceMappingURL=use-highlight-option.js.map


/***/ }),

/***/ 1120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ selectable_item; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/selectable-item/styles.scoped.css
var styles_scoped = __webpack_require__(4929);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/selectable-item/styles.css.js

/* harmony default export */ var styles_css = ({
    "selectable-item": "awsui_selectable-item_15o6u_1g6vu_93",
    "pad-bottom": "awsui_pad-bottom_15o6u_1g6vu_113",
    "has-background": "awsui_has-background_15o6u_1g6vu_122",
    "highlighted": "awsui_highlighted_15o6u_1g6vu_125",
    "selected": "awsui_selected_15o6u_1g6vu_125",
    "disabled": "awsui_disabled_15o6u_1g6vu_139",
    "next-item-selected": "awsui_next-item-selected_15o6u_1g6vu_147",
    "is-keyboard": "awsui_is-keyboard_15o6u_1g6vu_155",
    "parent": "awsui_parent_15o6u_1g6vu_159",
    "interactiveGroups": "awsui_interactiveGroups_15o6u_1g6vu_163",
    "child": "awsui_child_15o6u_1g6vu_175",
    "virtual": "awsui_virtual_15o6u_1g6vu_190",
    "measure-strut": "awsui_measure-strut_15o6u_1g6vu_201",
    "measure-strut-first": "awsui_measure-strut-first_15o6u_1g6vu_210",
    "screenreader-content": "awsui_screenreader-content_15o6u_1g6vu_214",
    "option-content": "awsui_option-content_15o6u_1g6vu_220"
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/selectable-item/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




var SelectableItem = function(_a, ref) {
    var _b;
    var content = _a.children, ariaSelected = _a.ariaSelected, ariaChecked = _a.ariaChecked, selected = _a.selected, highlighted = _a.highlighted, disabled = _a.disabled, hasBackground = _a.hasBackground, isParent = _a.isParent, isChild = _a.isChild, virtualPosition = _a.virtualPosition, padBottom = _a.padBottom, isNextSelected = _a.isNextSelected, useInteractiveGroups = _a.useInteractiveGroups, screenReaderContent = _a.screenReaderContent, ariaPosinset = _a.ariaPosinset, ariaSetsize = _a.ariaSetsize, highlightType = _a.highlightType, restProps = (0,tslib_es6/* __rest */._T)(_a, [
        "children",
        "ariaSelected",
        "ariaChecked",
        "selected",
        "highlighted",
        "disabled",
        "hasBackground",
        "isParent",
        "isChild",
        "virtualPosition",
        "padBottom",
        "isNextSelected",
        "useInteractiveGroups",
        "screenReaderContent",
        "ariaPosinset",
        "ariaSetsize",
        "highlightType"
    ]);
    var _c = (0,base_component/* getBaseProps */.j)(restProps), className = _c.className, rest = (0,tslib_es6/* __rest */._T)(_c, [
        "className"
    ]);
    var classNames = (0,clsx_m/* default */.Z)(className, styles_css["selectable-item"], (_b = {}, _b[styles_css.selected] = selected, _b[styles_css.highlighted] = highlighted, _b[styles_css["has-background"]] = hasBackground, _b[styles_css.parent] = isParent, _b[styles_css.child] = isChild, _b[styles_css["is-keyboard"]] = highlightType === "keyboard", _b[styles_css.disabled] = disabled, _b[styles_css.virtual] = virtualPosition !== undefined, _b[styles_css["pad-bottom"]] = padBottom, _b[styles_css["next-item-selected"]] = isNextSelected, _b[styles_css.interactiveGroups] = useInteractiveGroups, _b));
    var contentRef = (0,react.useRef)(null);
    var screenReaderContentRef = (0,react.useRef)(null);
    (0,react.useLayoutEffect)(function() {
        // the state of aria-hidden and announcement is not set back because NVDA+Firefox would announce
        // the item which lost highlight
        // set aria-hidden true when there is announcement content, so that screen reader still announce
        // meaningful content when navigate with screen reader cursor
        // imperatively update to avoid announcement made multiple times when content updates
        if (highlighted && screenReaderContent) {
            if (contentRef.current) {
                contentRef.current.setAttribute("aria-hidden", "true");
            }
            if (screenReaderContentRef.current) {
                screenReaderContentRef.current.textContent = screenReaderContent;
            }
        }
    }, [
        highlighted,
        screenReaderContent,
        contentRef,
        screenReaderContentRef
    ]);
    var style = virtualPosition !== undefined ? {
        transform: "translateY(".concat(virtualPosition, "px)")
    } : undefined;
    var a11yProperties = {
        "aria-disabled": disabled
    };
    if (isParent && !useInteractiveGroups) {
        a11yProperties["aria-hidden"] = true;
    }
    if (ariaSelected !== undefined) {
        a11yProperties["aria-selected"] = ariaSelected;
    }
    // Safari+VO needs aria-checked for multi-selection. Otherwise it only announces selected option even though another option is highlighted.
    if (ariaChecked !== undefined) {
        a11yProperties["aria-checked"] = ariaChecked;
    }
    if (ariaPosinset && ariaSetsize) {
        a11yProperties["aria-posinset"] = ariaPosinset;
        a11yProperties["aria-setsize"] = ariaSetsize;
    }
    return /*#__PURE__*/ react.createElement("li", (0,tslib_es6/* __assign */.pi)({
        role: "option",
        className: classNames,
        style: style
    }, a11yProperties, rest), /*#__PURE__*/ react.createElement("div", {
        className: styles_css["option-content"],
        ref: contentRef
    }, content), /*#__PURE__*/ react.createElement("div", {
        className: styles_css["measure-strut"],
        ref: ref
    }), /*#__PURE__*/ react.createElement("div", {
        className: styles_css["screenreader-content"],
        ref: screenReaderContentRef
    }));
};
/* harmony default export */ var selectable_item = (/*#__PURE__*/react.forwardRef(SelectableItem)); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 3686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ checkControlled; }
/* harmony export */ });
/* harmony import */ var _is_development__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5856);
/* harmony import */ var _logging__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3742);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function checkControlled(componentName, propertyName, propertyValue, handlerName, handlerValue) {
    if (propertyValue !== undefined && handlerValue === undefined && _is_development__WEBPACK_IMPORTED_MODULE_0__/* .isDevelopment */ .y) {
        (0,_logging__WEBPACK_IMPORTED_MODULE_1__/* .warnOnce */ .O)(componentName, "You provided `".concat(propertyName, "` prop without an `").concat(handlerName, "` handler. This will render a read-only component. If the component should be mutable, set an `").concat(handlerName, "` handler."));
    }
} //# sourceMappingURL=index.js.map


/***/ }),

/***/ 8518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ usePrevious; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * This hook gives the value of any variable from the previous render invocation
 */ var usePrevious = function(value) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        ref.current = value;
    });
    return ref.current;
}; //# sourceMappingURL=index.js.map


/***/ }),

/***/ 7073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ checkOptionValueField; }
/* harmony export */ });
/* harmony import */ var _internal_is_development__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5856);
/* harmony import */ var _internal_logging__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3742);
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0


function checkOptionValueField(componentName, propertyName, propertyValue) {
    if (_internal_is_development__WEBPACK_IMPORTED_MODULE_0__/* .isDevelopment */ .y) {
        if (!propertyValue) {
            return;
        }
        var valuePropertyMissing = !propertyValue.every(function(element) {
            return "options" in element || "value" in element;
        });
        if (valuePropertyMissing) {
            (0,_internal_logging__WEBPACK_IMPORTED_MODULE_1__/* .warnOnce */ .O)(componentName, "You provided an `".concat(propertyName, "` prop where at least one non-group array element is missing the `value` field. This field is required for all options without sub-items."));
        }
    }
} //# sourceMappingURL=check-option-value-field.js.map


/***/ }),

/***/ 3517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ useAnnouncement; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/option/option-announcer.js
function defaultOptionDescription(option, parentGroup) {
    return [
        parentGroup && parentGroup.label,
        option.__labelPrefix,
        option.label || option.value,
        option.description,
        option.labelTag
    ].concat(option.tags).filter(function(el) {
        return !!el;
    }).join(" ");
}
/* harmony default export */ var option_announcer = (defaultOptionDescription); //# sourceMappingURL=option-announcer.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/select/utils/use-announcement.js


/**
 * The hook produces the live region string to be announced when an option is highlighted.
 * This is a workaround to account for the issues with assistive technologies.
 *
 * If the testing reveals no issues with the native announcements the live-region can be removed.
 */ function useAnnouncement(_a) {
    var announceSelected = _a.announceSelected, highlightedOption = _a.highlightedOption, getParent = _a.getParent, selectedAriaLabel = _a.selectedAriaLabel, renderHighlightedAriaLive = _a.renderHighlightedAriaLive;
    var prevAnnouncedGroup = (0,react.useRef)(undefined);
    // Record previously announced group with a delay to account for possible re-renders of the hook.
    (0,react.useEffect)(function() {
        if (highlightedOption) {
            var frameId_1 = requestAnimationFrame(function() {
                prevAnnouncedGroup.current = getParent(highlightedOption);
            });
            return function() {
                return cancelAnimationFrame(frameId_1);
            };
        }
    });
    if (!highlightedOption) {
        return "";
    }
    var option = highlightedOption.option;
    var parent = getParent(highlightedOption);
    // Only announce parent group if it wasn't announced with previous option.
    var group = parent && parent !== prevAnnouncedGroup.current ? parent : undefined;
    // Use custom renderer if provided.
    if (renderHighlightedAriaLive) {
        return renderHighlightedAriaLive(option, group);
    }
    // Use default renderer with selected ARIA label if defined and relevant.
    var selectedAnnouncement = announceSelected && selectedAriaLabel ? selectedAriaLabel : "";
    var defaultDescription = option_announcer(option, group);
    return [
        selectedAnnouncement,
        defaultDescription
    ].filter(Boolean).join(" ");
} //# sourceMappingURL=use-announcement.js.map


/***/ }),

/***/ 3046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TextContent; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/text-content/styles.scoped.css
var styles_scoped = __webpack_require__(713);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/text-content/styles.css.js

/* harmony default export */ var styles_css = ({
    "text-content": "awsui_text-content_6absk_18dc1_94"
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/apply-display-name.js
var apply_display_name = __webpack_require__(1651);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-base-component/index.js + 2 modules
var use_base_component = __webpack_require__(4656);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/text-content/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0






function TextContent(_a) {
    var children = _a.children, props = (0,tslib_es6/* __rest */._T)(_a, [
        "children"
    ]);
    var __internalRootRef = (0,use_base_component/* default */.Z)("TextContent").__internalRootRef;
    var baseProps = (0,base_component/* getBaseProps */.j)(props);
    var className = (0,clsx_m/* default */.Z)(baseProps.className, styles_css["text-content"]);
    return /*#__PURE__*/ react.createElement("div", (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        className: className,
        ref: __internalRootRef
    }), children);
}
(0,apply_display_name/* applyDisplayName */.b)(TextContent, "TextContent"); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 5546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_textarea; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/events/index.js
var events = __webpack_require__(6322);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/context/form-field-context.js
var form_field_context = __webpack_require__(2308);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/forward-focus/index.js
var forward_focus = __webpack_require__(9283);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/textarea/styles.scoped.css
var styles_scoped = __webpack_require__(3786);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/textarea/styles.css.js

/* harmony default export */ var styles_css = ({
    "root": "awsui_root_qk1j1_114w0_93",
    "textarea": "awsui_textarea_qk1j1_114w0_97",
    "textarea-readonly": "awsui_textarea-readonly_qk1j1_114w0_121",
    "textarea-invalid": "awsui_textarea-invalid_qk1j1_114w0_157"
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/apply-display-name.js
var apply_display_name = __webpack_require__(1651);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-base-component/index.js + 2 modules
var use_base_component = __webpack_require__(4656);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/input/utils.js
var utils = __webpack_require__(6990);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/textarea/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0










var Textarea = /*#__PURE__*/ react.forwardRef(function(_a, ref) {
    var _b;
    var value = _a.value, _c = _a.autoComplete, autoComplete = _c === void 0 ? true : _c, disabled = _a.disabled, readOnly = _a.readOnly, disableBrowserAutocorrect = _a.disableBrowserAutocorrect, disableBrowserSpellcheck = _a.disableBrowserSpellcheck, spellcheck = _a.spellcheck, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onChange = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, ariaRequired = _a.ariaRequired, name = _a.name, rows = _a.rows, placeholder = _a.placeholder, autoFocus = _a.autoFocus, ariaLabel = _a.ariaLabel, rest = (0,tslib_es6/* __rest */._T)(_a, [
        "value",
        "autoComplete",
        "disabled",
        "readOnly",
        "disableBrowserAutocorrect",
        "disableBrowserSpellcheck",
        "spellcheck",
        "onKeyDown",
        "onKeyUp",
        "onChange",
        "onBlur",
        "onFocus",
        "ariaRequired",
        "name",
        "rows",
        "placeholder",
        "autoFocus",
        "ariaLabel"
    ]);
    var __internalRootRef = (0,use_base_component/* default */.Z)("Textarea").__internalRootRef;
    var _d = (0,form_field_context/* useFormFieldContext */.e)(rest), ariaLabelledby = _d.ariaLabelledby, ariaDescribedby = _d.ariaDescribedby, controlId = _d.controlId, invalid = _d.invalid;
    var baseProps = (0,base_component/* getBaseProps */.j)(rest);
    var textareaRef = (0,react.useRef)(null);
    (0,forward_focus/* default */.Z)(ref, textareaRef);
    var attributes = {
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby,
        "aria-required": ariaRequired ? "true" : undefined,
        "aria-invalid": invalid ? "true" : undefined,
        name: name,
        placeholder: placeholder,
        autoFocus: autoFocus,
        className: (0,clsx_m/* default */.Z)(styles_css.textarea, (_b = {}, _b[styles_css["textarea-readonly"]] = readOnly, _b[styles_css["textarea-invalid"]] = invalid, _b)),
        autoComplete: (0,utils/* convertAutoComplete */.q)(autoComplete),
        spellCheck: spellcheck,
        disabled: disabled,
        readOnly: readOnly ? true : undefined,
        rows: rows || 3,
        onKeyDown: onKeyDown && function(event) {
            return (0,events/* fireKeyboardEvent */.nm)(onKeyDown, event);
        },
        onKeyUp: onKeyUp && function(event) {
            return (0,events/* fireKeyboardEvent */.nm)(onKeyUp, event);
        },
        // We set a default value on the component in order to force it into the controlled mode.
        value: value || "",
        onChange: onChange && function(event) {
            return (0,events/* fireNonCancelableEvent */.B4)(onChange, {
                value: event.target.value
            });
        },
        onBlur: onBlur && function() {
            return (0,events/* fireNonCancelableEvent */.B4)(onBlur);
        },
        onFocus: onFocus && function() {
            return (0,events/* fireNonCancelableEvent */.B4)(onFocus);
        }
    };
    if (disableBrowserAutocorrect) {
        attributes.autoCorrect = "off";
        attributes.autoCapitalize = "off";
    }
    if (disableBrowserSpellcheck) {
        attributes.spellCheck = "false";
    }
    return /*#__PURE__*/ react.createElement("span", (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        className: (0,clsx_m/* default */.Z)(styles_css.root, baseProps.className),
        ref: __internalRootRef
    }), /*#__PURE__*/ react.createElement("textarea", (0,tslib_es6/* __assign */.pi)({
        ref: textareaRef,
        id: controlId
    }, attributes)));
});
(0,apply_display_name/* applyDisplayName */.b)(Textarea, "Textarea");
/* harmony default export */ var components_textarea = (Textarea); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 9656:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 4926:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 1176:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 4929:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 925:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 713:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 3786:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);